import FetchService from "./Shared/FetchService";
const baseURL = "/aviso/outreach";
export default class OutreachService {
    static search(params, options) {
        return FetchService.getSingleResponse(baseURL + "/search", {
            query: params.query,
            //  Only show active by default
            isActive: params.includeInactive == null ? true : !params.includeInactive,
            max: (options && options.max) || 30,
            offset: (options && options.offset) || 0,
        });
    }
    static findByIds(ids) {
        return FetchService.getSingleResponse(baseURL + "/search", {
            ids,
        });
    }
}
